module.exports = __webpack_public_path__ + "img/review.9fa18695.png";